import React, { Component } from 'react';
import './Lighting.css';
import LightingPDF from '../pdf/Lighting.pdf';
import ReactTooltip from 'react-tooltip';

import { find, isEqual } from 'lodash'

class Lighting extends Component {
  state = {
    data: []
  }

  constructor(props) {
    super(props);
  }

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.props.onOptionsUpdate({
      [name]: parseInt(value)
    });
  }

  //change the value of input form 07-10-18
  handleSelect = e => {
    this.props.onOptionsUpdate({
      [e.target.name]: e.target.value
    })
  }

  render() {
    console.log(this.state.data);
    const { options } = this.props;
    const SpaceLightingOption = props => <option selected={options.spaceLightingSystems === props.value} value={props.value}>{props.value}</option>
    const HallLightingOption = props => <option selected={options.hallLightingSystems === props.value} value={props.value}>{props.value}</option>
    const ExteriorLightingOption = props => <option selected={options.exteriorLightingSystems === props.value} value={props.value}>{props.value}</option>
    const ParkingLightingOption = props => <option selected={options.parkingLightingSystems === props.value} value={props.value}>{props.value}</option>
    console.log(options);
    return (
      <div>
        <div className="Lighting-Container">
          <div>

            <div className="form-group">
              <label className="App-bold" htmlFor="spaceLightingSystems">Occupied Space Lighting:</label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a data-tip="Most occupied space utilizes these of lighting fixtures" data-class='tool_tip' target="_blank" href={LightingPDF}><i class="fas fa-question-circle green-icon"></i></a> 
            <ReactTooltip place="top" type="info" effect="solid" />
              <select className="custom-select" name="spaceLightingSystems" onChange={this.handleSelect}>
                <SpaceLightingOption value="LED Lights" />
                <SpaceLightingOption value="T-5 Lights" />
                <SpaceLightingOption value="T-8 Lights" />
                <SpaceLightingOption value="T-12 Lights" />
                <SpaceLightingOption value="Incandescent Lights" />
                <SpaceLightingOption value="Compact Fluorescents" />
                <SpaceLightingOption value="High Bay T-5" />
                <SpaceLightingOption value="200W HPS Floods" />
                <SpaceLightingOption value="450W MH Floods" />
                <SpaceLightingOption value="1000W Watt Incandescent" />
              </select> 
            </div>

            <div className="form-group">
              <label className="App-bold" htmlFor="hallLightingSystems">Hallway Lighting System:</label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a data-tip="Most hallways utilize these of lighting fixtures" data-class='tool_tip' target="_blank" href={LightingPDF}><i class="fas fa-question-circle green-icon"></i></a> 
            <ReactTooltip place="top" type="info" effect="solid" />
              <select class="custom-select" name="hallLightingSystems" onChange={this.handleSelect}>
                <HallLightingOption value="LED Lights" />
                <HallLightingOption value="T-5 Lights" />
                <HallLightingOption value="T-8 Lights" />
                <HallLightingOption value="T-12 Lights" />
                <HallLightingOption value="Incandescent Lights" />
                <HallLightingOption value="Compact Fluorescents" />
                <HallLightingOption value="High Bay T-5" />
                <HallLightingOption value="200W HPS Floods" />
                <HallLightingOption value="450W MH Floods" />
                <HallLightingOption value="1000W Watt Incandescent" />
              </select>
            </div>

            <div className="form-group">
              <label className="App-bold" htmlFor="exteriorLightingSystems">Perimeter Lighting System:</label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a data-tip="The perimeter of the building uses these types of fixtures for lighting" data-class='tool_tip' target="_blank" href={LightingPDF}><i class="fas fa-question-circle green-icon"></i></a> 
            <ReactTooltip place="top" type="info" effect="solid" />
              <select class="custom-select" name="exteriorLightingSystems" onChange={this.handleSelect}>
              <option selected={this.props.options.exteriorLightingSystems === 'LED Lights'} value="LED Lights">LED Lights</option>
              {/* <ExteriorLightingOption value="LED Lights" /> */}
              <ExteriorLightingOption value="200W HPS Floods" />
              <ExteriorLightingOption value="250W MH Floods" />
              <ExteriorLightingOption value="450W MH Floods" />
              <ExteriorLightingOption value="1000W Watt Incandescent" /> 
              </select>
            </div>

            <div className="form-group">
              <label className="App-bold" htmlFor="parkingLightingSystems">Parking Lot Lighting System:</label>
              &nbsp;&nbsp;<a data-tip="The parking lots uses these types of fixtures for lighting" data-class='tool_tip' target="_blank" href={LightingPDF}><i class="fas fa-question-circle green-icon"></i></a> 
            <ReactTooltip place="top" type="info" effect="solid" />
              <select class="custom-select" name="parkingLightingSystems" onChange={this.handleSelect}>
              <option selected={this.props.options.parkingLightingSystems === 'LED Lights'} value="LED Lights">LED Lights</option>
              {/* <ParkingLightingOption value="LED Lights" /> */}
              <ParkingLightingOption value="200W HPS Floods" />
              <ParkingLightingOption value="250W MH Floods" />
              <ParkingLightingOption value="450W MH Floods" />
              <ParkingLightingOption value="1000W Watt Incandescent" />
              </select>
            </div>

          </div>
        </div>

      </div>

    );
  }
}

export default Lighting;


// WEBPACK FOOTER //
// ./src/components/Lighting.js